import { conditions } from "@/consts/offerConditions"

export default (backKey, backValue) => {
  const backValueInt = parseInt(backValue)
  const isUsedState = backKey === "used"
  const result = conditions.find((record) => {
    if (isUsedState) {
      return record.backKey === backKey && record.backValue === backValueInt
    } else {
      return record.backKey === backKey
    }
  })

  return result || null
}
